import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';

import { DownloadListItem } from './components';

const useStyles = makeStyles((theme) => ({
	root: {},
	title: {
		marginBottom: theme.spacing(3),
		marginTop: theme.spacing(4),
	},
	group: {
		'& + &': {
			marginTop: theme.spacing(4),
		},
	},
	file: {
		position: 'relative',
		'& + &': {
			marginTop: theme.spacing(3),
			'&:before': {
				position: 'absolute',
				content: '" "',
				height: 20,
				width: 1,
				top: -20,
				left: 20,
				backgroundColor: theme.palette.divider,
			},
		},
	},
}));

const DownloadList = (props) => {
	const { files, className, ...rest } = props;

	const classes = useStyles();

	const todayItems = files.filter(item => moment(item.addedDate).isSame(moment(), 'day'));
	const yesterdayItems = files.filter(item => moment(item.addedDate).isSame(moment().subtract(1, 'day'), 'day'));
	const olderItems = files.filter(item => moment(item.addedDate).isBefore(moment().subtract(1, 'day'), 'day'));

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			{todayItems.length > 0 && (
				<>
					<Typography className={classes.title} variant="h3">
						Today
					</Typography>
					<div className={classes.group}>
						{todayItems.map((file) => (
							<DownloadListItem
								file={file}
								className={classes.file}
								key={`TodayDownloadListItem${file.id}`}
							/>
						))}
					</div>
				</>
			)}
			{yesterdayItems.length > 0 && (
				<>
					<Typography className={classes.title} variant="h3">
						Yesterday
					</Typography>
					<div className={classes.file}>
						{yesterdayItems.map((file) => (
							<DownloadListItem
								file={file}
								className={classes.file}
								key={`YesterdayDownloadListItem${file.id}`}
							/>
						))}
					</div>
				</>
			)}
			{olderItems.length > 0 && (
				<>
					<div className={classes.group}>
						<Typography className={classes.title} variant="h3">
							Older
						</Typography>
						{olderItems.map((file) => (
							<DownloadListItem
								file={file}
								className={classes.file}
								key={`OlderDownloadListItem${file.id}`}
							/>
						))}
					</div>
				</>
			)}
		</div>
	);
};

DownloadList.propTypes = {
	files: PropTypes.array.isRequired,
	className: PropTypes.string,
};

export default DownloadList;
